
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "startNewBooking",
      resolverType: "mutation",
      routePath: "/startNewBooking",
      httpMethod: "POST",
    });
  